function glowRevealTitle(element, triggerElement, tl = null, option = { duration: 0.8}) {

  if (!element) return;

  const fromVars = {
    opacity: 0,
    // y: 30,
    filter: "blur(12px) brightness(2.5)"
  };

  const toVars = {
    opacity: 1,
    // y: 0,
    filter: "blur(0px) brightness(1)",
    duration: option.duration,
    ease: "power3.out"
  };

  // If timeline is provided → add to timeline
  if (tl) {
    tl.fromTo(element, fromVars, toVars);
  } 
  // Otherwise run standalone animation
  else {
    gsap.fromTo(element, fromVars, {
      ...toVars,
      scrollTrigger: {
        trigger: triggerElement || element,
        start: "top 80%",
        once: true
      }
    });
  }

}

function glowRevealElement(element, triggerElement, tl = null) {

  if (!element) return;

  const fromVars = {
    opacity: 0,
    filter: "blur(12px)"
  };

  const toVars = {
    opacity: 1,
    filter: "blur(0px)",
    duration: 0.8,
    ease: "power1.out"
  };

  // If timeline is provided → add to timeline
  if (tl) {
    tl.fromTo(element, fromVars, toVars);
  } 
  // Otherwise run standalone animation
  else {
    gsap.fromTo(element, fromVars, {
      ...toVars,
      scrollTrigger: {
        trigger: triggerElement || element,
        start: "top 85%",
        once: true
      }
    });
  }

}

function revealItems({
  items,
  trigger,
  y = 40,
  duration = 1,
  ease = "sine.out",
  stagger = 0.15,
  staggerFrom = "start",
  start = "top 85%",
  once = true
}) {
  const elements = gsap.utils.toArray(items);
 
  if (!elements.length) return;

  gsap.set(elements, { opacity: 0, y });

  return gsap.timeline({
    scrollTrigger: {
      trigger: trigger || elements[0],
      start,
      once
    }
  }).to(elements, {
    opacity: 1,
    y: 0,
    duration,
    ease,
    stagger: {
      each: stagger,
      from: staggerFrom
    }
  });
}